import { render, staticRenderFns } from "./ProductItemtwo.vue?vue&type=template&id=30d55ec5&scoped=true"
import script from "./ProductItemtwo.vue?vue&type=script&lang=js"
export * from "./ProductItemtwo.vue?vue&type=script&lang=js"
import style0 from "./ProductItemtwo.vue?vue&type=style&index=0&id=30d55ec5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d55ec5",
  null
  
)

export default component.exports